import React, { ComponentType } from 'react';

import { ClientLocationStatusList, GetClientLocationsByStatusComponent } from 'api';
import { QueryManager } from 'components';

export interface IWithClientLocations {
  clientLocations: ClientLocationStatusList;
}

const withClientLocations = <T extends {}>(Component: ComponentType<T & IWithClientLocations>) => (
  props: T,
) => (
  <GetClientLocationsByStatusComponent>
    {queryResult => (
      <QueryManager {...queryResult}>
        {({ data }) => {
          if (!data || !data.getClientLocationsByStatus) {
            return (
              <Component
                {...props}
                clientLocations={{ client_locations: [], count: 0, paginate: false }}
              />
            );
          }

          return <Component {...props} clientLocations={data.getClientLocationsByStatus} />;
        }}
      </QueryManager>
    )}
  </GetClientLocationsByStatusComponent>
);

export default withClientLocations;
